const ApplicationTypes = {
  START_CREATE_APPLICATION: 'START_CREATE_APPLICATION',
  CREATE_APPLICATION_SUCCESS: 'CREATE_APPLICATION_SUCCESS',
  CREATE_APPLICATION_FAILURE: 'CREATE_APPLICATION_FAILURE',

  START_EDIT_APPLICATION: 'START_EDIT_APPLICATION',
  EDIT_APPLICATION_SUCCESS: 'EDIT_APPLICATION_SUCCESS',
  EDIT_APPLICATION_FAILURE: 'EDIT_APPLICATION_FAILURE',

  START_FETCH_APPLICATIONS: 'START_FETCH_APPLICATIONS',
  FETCH_APPLICATIONS_SUCCESS: 'FETCH_APPLICATIONS_SUCCESS',
  FETCH_APPLICATIONS_FAILURE: 'FETCH_APPLICATIONS_FAILURE',

  START_FETCH_SINGLE_APPLICATIONS: 'START_FETCH_SINGLE_APPLICATIONS',
  FETCH_SINGLE_APPLICATIONS_SUCCESS: 'FETCH_SINGLE_APPLICATIONS_SUCCESS',
  FETCH_SINGLE_APPLICATIONS_FAILURE: 'FETCH_SINGLE_APPLICATIONS_FAILURE',

  DELETE_APPLICATION_START: 'DELETE_APPLICATION_START',
  DELETE_APPLICATION_SUCCESS: 'DELETE_APPLICATION_SUCCESS',
  DELETE_APPLICATION_FAIL: 'DELETE_APPLICATION_FAIL',

  SET_DATA: 'SET_DATA',

  ADD_APPLICATION_DATA: 'ADD_APPLICATION_DATA',

  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',

  START_FETCH_COURSES: 'START_FETCH_COURSES',
  FETCH_COURSES_SUCCESS: 'FETCH_COURSES_SUCCESS',
  FETCH_COURSES_FAILURE: 'FETCH_COURSES_FAILURE',

  START_APPLICATIONS_SEARCH: 'START_APPLICATIONS_SEARCH',
  FILTER_APPLICATIONS: 'FILTER_APPLICATIONS',
  SEARCH_APPLICATION_SUCCESS: 'SEARCH_APPLICATION_SUCCESS',

  SEARCH_CANDIDATE_GROUPS: 'SEARCH_CANDIDATE_GROUPS',
  SEARCH_CANDIDATE_GROUPS_SUCCESS: 'SEARCH_CANDIDATE_GROUPS_SUCCESS',
  SEARCH_CANDIDATE_GROUPS_ERROR: 'SEARCH_CANDIDATE_GROUPS_ERROR',

  FETCH_SINGLE_GROUP: 'FETCH_SINGLE_GROUP',
  FETCH_SINGLE_GROUP_SUCCESS: 'FETCH_SINGLE_GROUP_SUCCESS',
  FETCH_SINGLE_GROUP_ERROR: 'FETCH_SINGLE_GROUP_ERROR',
};

export default ApplicationTypes;
